import { TrendMetricCard } from "../components/TrendMetricCard"
import {
  EngagementKpiGrid,
  EngagementSectionCard,
  MobileGroupTitle,
  MobileKpiGroup,
  SectionSubtitle,
  SectionTitle,
} from "./styled"
import type { EngagementKpiMetric, EngagementPeriodLabels, MobileWeeklyTrend } from "./types"
import { WeeklyTrendChart } from "./WeeklyTrendChart"

const mobileSeries = [
  { key: "navigation" as const, label: "Navigation", color: "#3b82f6" },
  { key: "requests" as const, label: "Requests", color: "#a855f7" },
  { key: "contact" as const, label: "Contact", color: "#6366f1" },
  { key: "website" as const, label: "Website", color: "#22d3ee" },
]

interface MobileAppEngagementProps {
  kpiGroups: Array<{ title: string; metrics: EngagementKpiMetric[] }>
  weeklyTrend: MobileWeeklyTrend[]
  periodLabels: EngagementPeriodLabels
}

export const MobileAppEngagement = ({ kpiGroups, weeklyTrend, periodLabels }: MobileAppEngagementProps) => (
  <EngagementSectionCard>
    <div>
      <SectionTitle>Mobile App Engagement</SectionTitle>
      <SectionSubtitle>Customer interactions within the mobile application</SectionSubtitle>
    </div>
    {kpiGroups.map(group => (
      <MobileKpiGroup key={group.title}>
        <MobileGroupTitle>{group.title}</MobileGroupTitle>
        <EngagementKpiGrid>
          {group.metrics.map(metric => (
            <TrendMetricCard key={metric.id} metric={metric} periodLabels={periodLabels} />
          ))}
        </EngagementKpiGrid>
      </MobileKpiGroup>
    ))}
    <WeeklyTrendChart data={weeklyTrend} series={mobileSeries} />
  </EngagementSectionCard>
)
